import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApiVideoLection } from './getApiVideoLection';

export const apiGetVideoLection = async (name: string) => {
  const params: IApiParams = {
    url: `/getVideoLection.php?name=${name}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApiVideoLection(params, 'GET');
};
